import styles from "../Components/ProductList.module.css";
const Hotels = () => {
    return <>
        <div className={`col-sm-12 ${styles.mainContainer}`}>
        <div className="container-fluid">          
          <div className="row">
            {/* { services.map((item)=>(<HomeServicesItem key={item.id} item={item} />
            ))}        */}
          </div>
        </div>
      </div>
      </>
}
export default Hotels;